export class LoadingDot {
  static _instance = null;

  constructor() {
    if (LoadingDot._instance) {
      throw new Error("Error: debe implementar LoadingDot.getInstance() para utilizar el singleton.");
    }
  }

  static getInstance() {
    if (!LoadingDot._instance) {
      LoadingDot._instance = new LoadingDot();
    }
    return LoadingDot._instance;
  }

  static render() {
    return '<div class="loader gray"></div>';
  }
}
